import type { ReactNode } from 'react';
import {
  JyotishaLanguageProvider,
  JYOTISHA_LANG_STORAGE_KEYS,
} from 'schools/parashari/components/jyotisha/JyotishaLanguageContext';

export function AiRouteLanguageProvider({ children }: { children: ReactNode }) {
  return (
    <JyotishaLanguageProvider storageKey={JYOTISHA_LANG_STORAGE_KEYS.ai}>
      {children}
    </JyotishaLanguageProvider>
  );
}
